// Phase 2 Migration Wrapper

import { getOrCreateKeyPairPhase2 } from './crypto.phase2';
import { migrateLegacyPrivateKey, cleanupLegacyPrivateKey } from './keyMigration';

export async function getOrCreateKeyPairSafe(userId: string) {
  // Step 1: attempt migration
  const { migrated, key } = await migrateLegacyPrivateKey(userId);

  if (key) {
    if (migrated) {
      console.log('[KEY-MIGRATION] Migrated legacy key to secure vault');
      // optional cleanup (can delay if cautious rollout)
      cleanupLegacyPrivateKey(userId);
    }
    return { privateKey: key };
  }

  // Step 2: fallback to new secure generation
  return getOrCreateKeyPairPhase2(userId);
}
